
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gU_45M8UUBMNwwE7_45esUOO4RiGM6ctyMsOqFJbz3aBbwTUMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexKEm7OSa9ZwnMR6QuctwzL870PzTz8TD09dlH2_55OI0Meta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchqm3G6p4blk2NmGS3nDUjfLiAIdxqI20VhgdlXmRt_45M0Meta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexIekDCxpgLXfvKChd9Ar_KNQWuvgQR0leYUzlcBADvGEMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93fHKJfdgRkbA_MGy3OqIjvWJfscaOiPH0dejy2YK_lBUMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexTVbtyeozuAUbEdOB5AKHzHl_d1QodA_45_lKv9aBify6MMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Kcsl78F3o6jDwqrSJ3fjZHmClGSX5oQ973rweZjQQ7EMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexIsVHtyq4pMU93vhiA0FXOuHsZ26kWrZyYeMHqDo3Bn0Meta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93eNUFSBl_45tfCH4uw2KGnkSbiRJqNgIFrraH3fdY_45nPm4Meta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpUQmjdtQYO4LoSRgyVyaYsZ9EWTc1XDq8UDtk0uEQUoMeta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index508pAOXUw91SEtwceCd_WcetII_45HsFb9ReCgIGoZ9r8Meta } from "/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexTVbtyeozuAUbEdOB5AKHzHl_d1QodA_45_lKv9aBify6MMeta || {},
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexIsVHtyq4pMU93vhiA0FXOuHsZ26kWrZyYeMHqDo3Bn0Meta || {},
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpUQmjdtQYO4LoSRgyVyaYsZ9EWTc1XDq8UDtk0uEQUoMeta || {},
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index508pAOXUw91SEtwceCd_WcetII_45HsFb9ReCgIGoZ9r8Meta || {},
    component: () => import("/codebuild/output/src2677700189/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]